export default __webpack_public_path__ + "static/media/sort-icon.e9aab391.svg";